export default __webpack_public_path__ + "static/splash_full-f7aa05294f6ed97e36da69a346d6f793.jpg";